<template>
  <v-dialog :value="showDialog"
    :retain-focus="false"
    persistent
    content-class="download-dialog">
    <v-card>
      <v-toolbar class="escalon-dialog-header" height="35">
        <img
          class="modal-axis-logo mr-2"
          :src="require('../../assets/' + coloredLogo)" />
        <span>Edit Text</span>
        <v-spacer />
        <close-button @click="closeModal" />
      </v-toolbar>
      <v-card-text class="escalon-dialog-content justify-center">
        <div class="text-left">
          <label class="modal-label">Annotation Text</label>
        </div>
        <v-textarea
          solo
          auto-grow
          v-model="text"
          autocomplete="off"
          name="textAnnotationToEdit.text"
          data-vv-as="Annotation Text"/>
        <v-container fluid grid-list-md>
          <v-layout wrap>
            <v-flex md6>
              <div class="text-left">
                <label class="modal-label">Text size</label>
              </div>
              <v-combobox
                :value="textSize"
                @input="updateTextSize"
                @change="updateTextSize"
                :items="textOptions"
                :return-object="false"
                item-value="size"
                solo>
                <template slot="item" slot-scope="props">
                  <v-icon class="mr-2">{{props.item.icon}}</v-icon>
                  {{props.item.size}} pt
                </template>
              </v-combobox>
            </v-flex>
            <v-flex md6>
              <div class="text-left">
                <label class="modal-label">Background Fill</label>
              </div>
              <v-combobox
                :value="showBackgroundBox"
                @input="updateShowBackgroundBox"
                @change="updateShowBackgroundBox"
                :items="showBackgroundBoxOptions"
                solo/>
            </v-flex>
          </v-layout>
        </v-container>
        <div class="text-left">
          <label class="modal-label">Font Color</label>
        </div>
        <annotation-color-picker
          :value="fontColor"
          @input="updateColor($event)"/>
        <v-btn text class="modal-cta" @click="updateAnnotationText">Submit</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import closeButton from "../../components/controls/CloseButton";
import annotationColorPicker from "../../components/imageBrowser/controls/AnnotationColorPicker";
import { mapGetters } from "vuex";
import { TEXT_SIZES, SHOW_BACKGROUND_BOX, ANNOTATION_COLORS } from "../../config/config";

export default {
  name: "editAnnotationTextDialog",
  components: { closeButton, annotationColorPicker },
  data() {
    return {
      text: "",
      size: 40,
      sizes: TEXT_SIZES,
      showBackgroundBox: { value: true, text: "Yes" },
      showBackgroundBoxOptions: SHOW_BACKGROUND_BOX,
      fontColor: ANNOTATION_COLORS.Black
    };
  },
  computed: {
    ...mapGetters(["textAnnotationToEdit", "sideBySideIsSynced"]),
    showDialog() {
      return !!this.textAnnotationToEdit;
    },
    textOptions() {
      return this.sizes.map(s => {
        return {
          size: s,
          icon:
            this.size === s
              ? "far fa-check-square"
              : "far fa-square"
        };
      });
    },
    textSize() {
      return this.size + " pt";
    }
  },
  methods: {
    closeModal() {
      this.$store.commit("setTextAnnotationToEdit", null);
    },
    updateTextSize(size) {
      this.size = Number(size) || 40;
    },
    updateShowBackgroundBox(val) {
      this.showBackgroundBox = val;
    },
    updateColor(color) {
      this.fontColor = color;
    },
    updateAnnotationText() {
      this.textAnnotationToEdit.updateTextSize(this.size);
      this.textAnnotationToEdit.updateTextArea(this.text);
      this.textAnnotationToEdit.setShowBackgroundBox(this.showBackgroundBox);
      this.textAnnotationToEdit.updateFontColor(this.fontColor);
      this.textAnnotationToEdit.setWidthToText();
      this.textAnnotationToEdit.clearActiveStates();
      if (this.sideBySideIsSynced) this.$store.commit("syncAnnotationText");
      this.closeModal();
    }
  },
  watch: {
    showDialog() {
      if (this.showDialog) {
        this.text = this.textAnnotationToEdit.text;
        this.size = this.textAnnotationToEdit.size;
        this.showBackgroundBox = this.textAnnotationToEdit.showBackgroundBox == true ? { value: true, text: "Yes" } : { value: false, text: "No" };
        this.fontColor = this.textAnnotationToEdit.fontColor;
      }
    }
  }
};
</script>